<template>
  <div>
    <div >
      <!-- Current Password Input -->
      <Input
        :value="formValues.currentPassword"
        @input="(value: string) => updateFn('currentPassword', value)"
        :placeholder="t('profile.currentPasswordPlaceholder')"
        :error="t('loginRegister.contacts_password_format_lenght')"
        :showError="showErrors && invalidFields.has('currentPassword')"
        :inputType="showPasswords.current ? 'text' : 'password'"
        required
      >
        <template #after>
          <EyeIcon
            @click.stop="$emit('togglePasswordVisibility', 'current')"
            :color="showPasswords.current ? '#000000' : '#CED4DA'"
          />
        </template>
      </Input>

      <!-- New Password Input -->
      <Input
      :value="formValues.newPassword"
        @input="(value: string) => updateFn('newPassword', value)"
        :placeholder="t('profile.newPasswordPlaceholder')"
        :error="t('loginRegister.contacts_password_format_lenght')"
        :showError="showErrors && invalidFields.has('newPassword')"
        :inputType="showPasswords.new ? 'text' : 'password'"
        required
      >
        <template #after>
          <EyeIcon
            @click.stop="$emit('togglePasswordVisibility', 'new')"
            :color="showPasswords.new ? '#000000' : '#CED4DA'"
          />
        </template>
      </Input>

      <!-- Confirm Password Input -->
      <Input
        :value="formValues.confirmPassword"
        @input="(value: string) => updateFn('confirmPassword', value)"
        :placeholder="t('profile.confirmPasswordPlaceholder')"
        :error="getConfirmErrorMessage()"
        :showError="showErrors && invalidFields.has('confirmPassword')"
        :inputType="showPasswords.confirm ? 'text' : 'password'"
        required
      >
        <template #after>
          <EyeIcon
            @click.stop="$emit('togglePasswordVisibility', 'confirm')"
            :color="showPasswords.confirm ? '#000000' : '#CED4DA'"
          />
        </template>
      </Input>
    </div>
  </div>
</template>

<script lang="ts" setup>
  /**
   * Imports and Dependencies
   */
  import { useI18n } from 'vue-i18n'
  import Input from '@/components/UI/Input.vue'
  import EyeIcon from '@/assets/EyeIcon.vue'
  import { defineProps, defineEmits } from 'vue'

  // Types
  import { FormValues, ShowPasswords, UpdateFn, ValidationFields, PASSWORD_LENGTH } from './EditPassword';

  /**
   * Props Definitions
   */
  interface Props {
    updateFn: UpdateFn,
    formValues: FormValues,
    invalidFields: ValidationFields
    showErrors: boolean
    showPasswords: ShowPasswords
  }

  const props = defineProps<Props>()
  
  /**
   * Emitted Events
   */
   defineEmits([
    'togglePasswordVisibility',
  ])


  // Methods
  const getConfirmErrorMessage = (): string => {
    // Default
    let message = t('loginRegister.contacts_password_format_lenght')

    // Display different error if not equal
    if(props.formValues.confirmPassword !== props.formValues.newPassword) {
      message = t('loginRegister.contacts_passwords_dont_match')
    } 

    return message
  }

  /**
   * Localization
   */
  const { t } = useI18n()
</script>

<style scoped>
  /**
 * Scoped Styles
 */
  .error {
    color: red;
    margin-top: 1rem;
  }

  ::v-deep .container-wrapper {
    position: relative;
  }

  ::v-deep .slot-after {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    padding: 0;
  }

  ::v-deep .slot-after > * {
    cursor: pointer;
  }

  ::v-deep .disabled-eye {
    cursor: not-allowed;
    pointer-events: none;
    color: #ced4da;
  }
</style>./EditPassword
